import { render, staticRenderFns } from "./sn-popup.vue?vue&type=template&id=24ae66d6"
import script from "./sn-popup.vue?vue&type=script&lang=js"
export * from "./sn-popup.vue?vue&type=script&lang=js"
import style0 from "./sn-popup.vue?vue&type=style&index=0&id=24ae66d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports